module.exports = __webpack_public_path__ + "static/media/warning.6391cc7c.svg";